import { styled, Box } from '@mui/material';
import { rem, Bold } from '@core-web/typography';

export const Wrapper = styled(Box)(() => ({
  width: 'auto',
  minWidth: 0,
  '.MuiInputBase-root': {
    height: `${rem(36)} !important`,
  },
  '.MuiAutocomplete-root': {
    width: '100%',
  },
  flex: 1,
}));
export const PageFormEmailListInputWrapper = styled(Box)(({ theme: { palette } }) => ({
  width: '100%',
  height: `${rem(30)} !important`,
  display: 'flex',
  paddingBottom: rem(10),
  alignItems: 'center',
  gap: rem(4),
  flex: 1,
  borderBottom: `1px solid ${palette.colors.grey_200}`,
}));
export const EmailListLabel = styled(Box)(({ theme: { palette } }) => ({
  width: 'max-content',
  display: 'flex',
  alignItems: 'center',
  color: palette.colors.grey_500,
  fontSize: rem(14),
  fontWeight: Bold._500,
  lineHeight: rem(20),
}));

export const EmailListInput = styled(Box)(({}) => ({
  display: 'flex',
  alignItems: 'center',
  flexGrow: 1,
}));

export const LeftSection = styled(Box)(({}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
  gap: rem(4),
  marginRight: rem(8),
  height: 'max-content',
  alignSelf: 'baseline',
  minHeight: rem(34),
}));

export const IconWrapper = styled(Box)(({}) => ({
  display: 'flex',
  width: rem(20),
  height: rem(20),
  fontSize: rem(20),
}));

export const LabelStyle = {
  lineHeight: rem(20),
  fontWeight: Bold._500,
  padding: 0,
  margin: 0,
  height: 'auto',
};

interface ICenterSection {
  /**
   * Whether to disable the fixed height of the center section
   */
  disableFixedHeight?: boolean;
}

export const CenterSection = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'disableFixedHeight',
})<ICenterSection>(({ disableFixedHeight }) => ({
  display: 'flex',
  ...(!disableFixedHeight && { height: '100%' }),
}));
